import type {Lead} from "@project/application/sales/leads";

import {getLeadQueryOptions} from "@project/application/sales/leads";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";
import {z} from "zod";

import {routeMessages} from "../../../../../messages/routes.messages";

import {LeadPage} from "./-page/lead.page";
import {LeadPending} from "./-page/lead.pending";

const leadSearchSchema = z.object({includeDeleted: z.boolean().optional().default(false)});

export const Route = createFileRoute("/_app/sales/leads/$leadId")({
  component: RouteComponent,
  errorComponent: AppErrorBoundary,
  validateSearch: leadSearchSchema,
  loader: async ({context: {queryClient}, params, deps}) =>
    queryClient.ensureQueryData(
      getLeadQueryOptions(params.leadId, (deps as {includeDeleted: boolean}).includeDeleted),
    ),
  loaderDeps: ({search}) => ({
    includeDeleted: (search as {includeDeleted: boolean}).includeDeleted,
  }),
  pendingComponent: LeadPending,
  staticData: {
    meta: {
      getLabel: (_p: Record<string, string>, data?: unknown) =>
        (data as Lead | undefined)?.company.companyName,
      getLabelDescriptor: (p: Record<string, string>) => ({
        id: routeMessages.leadById.id,
        values: {leadId: p["leadId"]},
      }),
    },
  },
});

function RouteComponent() {
  const {leadId} = Route.useParams();
  const {includeDeleted} = Route.useSearch();

  return <LeadPage includeDeleted={includeDeleted} leadId={leadId} />;
}
